import { Component } from 'react';
import { Alert } from 'reactstrap';
import ConfirmData from '../../../elements/Booking/Customer/ConfirmData';
import axios from 'axios';
import queryString from 'query-string';
import BookingSiteContainer from './BookingSiteContainer';
import Texts from '../../../json/texts.json';
import { getTranslationKey } from '../../../modules/utils/helpers';
import { RouteComponentProps } from 'react-router-dom';

interface Product {
  _id: string;
  title: string;
  description: string;
  price: number;
  currency: string;
  duration: number;
}

interface Lead {
  _id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_no: string;
}

interface BookingSite {
  _id: string;
  title: string;
  image: string;
  thankYouUrl?: string;
}

interface Appointment {
  _id: string;
  start: Date;
  end: Date;
}

interface BookingConfirmState {
  product: Product | Record<string, never>;
  lead: Lead | Record<string, never>;
  bookingSite: BookingSite | Record<string, never>;
  paymentId?: string;
  PayerID?: string;
  paymentStatus?: string;
  appointment?: Appointment;
  status?: 'success' | 'danger';
  loading?: boolean;
}

class BookingConfirm extends Component<RouteComponentProps, BookingConfirmState> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.state = {
      product: {},
      lead: {},
      bookingSite: {}
    };

    this.completePayment = this.completePayment.bind(this);
  }

  UNSAFE_componentWillMount(): void {
    const parsed = queryString.parse(this.props.location.search);
    const { paymentId, PayerID } = parsed;
    this.loadTransaction(paymentId as string);
    this.setState({ paymentId: paymentId as string, PayerID: PayerID as string });
  }

  async loadTransaction(paymentId: string): Promise<void> {
    if (paymentId) {
      try {
        const result = await axios.get(
          `/api/bookingPaymentTransaction?paypal_paymentId=${paymentId}`
        );
        const { product, lead, bookingSite, appointment, status } = result.data;
        this.setState({
          product,
          lead,
          bookingSite,
          paymentStatus: status,
          appointment
        });
      } catch (e) {
        console.log(e);
      }
    }
  }

  async completePayment(): Promise<void> {
    try {
      this.setState({ loading: true });
      const { paymentId, PayerID, bookingSite } = this.state;
      await axios.post('/api/booking/approvepayment', {
        paymentId,
        PayerID
      });
      this.setState({ status: 'success' });
      if ((bookingSite as BookingSite).thankYouUrl) {
        window.location.href = (bookingSite as BookingSite).thankYouUrl!;
      } else {
        this.setState({ loading: false });
      }
    } catch (e) {
      console.log(e);
      this.setState({ status: 'danger', loading: false });
    }
  }

  render(): JSX.Element {
    const { bookingSite, status, paymentStatus } = this.state;
    if (!(bookingSite as BookingSite)._id || this.state.loading) {
      return (
        <div className="loading">
          <div className="loader" />
        </div>
      );
    }

    return (
      <BookingSiteContainer bookingSite={bookingSite as BookingSite}>
        <ConfirmData
          lead={this.state.lead as Lead}
          product={this.state.product as Product}
          appointment={this.state.appointment}
        />
        <button
          className="btn btn-primary w-100-p btn-booking"
          onClick={this.completePayment}
          disabled={status === 'success' || paymentStatus === 'confirmed'}
        >
          {getTranslationKey('bookMandatory')}
        </button>
        {paymentStatus === 'confirmed' && (
          <Alert className="m-t-10" color="success">
            {Texts[0]['booking-already-done']}
          </Alert>
        )}
        {status && (
          <Alert className="m-t-10" color={status}>
            {Texts[0][`booking-${status}`]}
          </Alert>
        )}
      </BookingSiteContainer>
    );
  }
}

export default BookingConfirm;
